<!--
  @author Simeon Artamonov <simeon@cross-works.co.uk>
  @company Cross Works Ltd
-->
<template>
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="youtube-icon"
  >
    <path 
      d="M8 12.6592L13.19 9.69212L8 6.72509V12.6592ZM19.56 4.9152C19.69 5.38003 19.78 6.00311 19.84 6.79432C19.91 7.58553 19.94 8.26794 19.94 8.86135L20 9.69212C20 11.8581 19.84 13.4504 19.56 14.469C19.31 15.3592 18.73 15.9328 17.83 16.18C17.36 16.3086 16.5 16.3976 15.18 16.457C13.88 16.5262 12.69 16.5559 11.59 16.5559L10 16.6152C5.81 16.6152 3.2 16.457 2.17 16.18C1.27 15.9328 0.69 15.3592 0.44 14.469C0.31 14.0042 0.22 13.3811 0.16 12.5899C0.0900001 11.7987 0.0599999 11.1163 0.0599999 10.5229L0 9.69212C0 7.52619 0.16 5.93388 0.44 4.9152C0.69 4.02509 1.27 3.45146 2.17 3.20421C2.64 3.07564 3.5 2.98663 4.82 2.92728C6.12 2.85805 7.31 2.82838 8.41 2.82838L10 2.76904C14.19 2.76904 16.8 2.92728 17.83 3.20421C18.73 3.45146 19.31 4.02509 19.56 4.9152Z" 
      fill="var(--theme-link)"
    />
  </svg>
</template>

<script setup>
// No props or computed properties needed as we're using CSS variables
</script>

<style lang="scss" scoped>
@use '../../assets/scss/variables' as *;
.youtube-icon path {
  transition: fill $animation-speed-medium ease-out;
}

.youtube-icon:hover path {
  fill: var(--theme-link-hover);
}

.youtube-icon:active path {
  fill: var(--theme-link-active);
}
</style>